//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

//  -- Components ---------------------
import { Dropdown } from 'antd';

//  -- Constants ----------------------
import {
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material';
import { Button, Snackbar } from '@mui/material';
import ResizeAndDragabble from "components/ResizeAndDraggableWidget";

import { Alert } from '@mui/material';

import * as Sentry from '@sentry/react';
import { filter, find, get, has } from 'lodash';
import VocabPrint from 'modules/PrintVocabulary/VocabPrint';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setAudioChecker } from 'store/audio/actions';
import { useAllBook } from 'store/books/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { useCognets } from 'store/cogantes/selectors';
import {
  handleListVocabularyCogantes,
  handleListVocabularyCogStud,
} from 'store/cogantes/thunks';
import { useExams } from 'store/exams/selectors';
import { useClassUsers } from 'store/userClasses/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useVoabPermissionForUser, useClassTogglePermission, useCurrentOrgPermission } from 'store/organizations/selectors';
import { useBookOrder } from 'store/books/selectors';
import {
  handleGetStudentWordCount,
  handleListVocabularyStud,
} from 'store/vocabulary/thunks';
import { question_type_generate_more } from 'utils/config/reference';
import { useAudio } from 'utils/context/AudioProvider';
import CognateAiLoader from 'components/ebook/cogantes/cognateAiModal';
import { useOrientation } from 'components/hooks';
import { useFocusOutside } from 'components/OnClickOutside';
import { useMobileDetect } from 'hooks/useMobileDetect';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useConfirm } from 'components/UI/confirmProvider';
import QnALoader from 'components/VocabQnAModal/QnALoader';
import Cogantes from 'components/ebook/cogantes';
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import { handleStreamResponseForCognates } from 'utils/methods/CognatesStreamHandler';
import { createVocabularySuccessCogantes } from 'store/cogantes/actions';
import { ItemLoader } from 'components/Loader/ItemLoader';
import useBook from 'components/hooks/books/useBook';
import { useIsAdditionalBook } from 'utils/methods/functions';
import { useUserProfileConfig } from 'store/users/selectors';
import SentryWrap from 'components/Sentry';

const ModalContent = styled.div`
  position: relative;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  height: 100%;
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  z-index: 999999999;
`;

const CrossPrint = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
  z-index: 99999;
  // width: 100px;
`;

const DROPDOWN_Z_INDEX = 1000000001;

const languageMenuItems = [
  {
      key: 'spanish',
      label: 'Spanish'
  },
  {
      key: 'english',
      label: 'English'
  }
];

const CognatesComponent = ({
  pageNumber,
  pageId,
  bookId,
  style,
  isCheckingOpen,
  setVocModal,
  vocabilaryButtonClassName = '',
  isVocabulary = false,
  isOnlyForTeacher = false,
  from = '',
  closeToolsDropdown = () => {}
}) => {
  const showAlert = useAlert();
  const confirm = useConfirm();
  const { ref, isFocused } = useFocusOutside();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const bookCognets = useCognets();
  const classUsers = useClassUsers();
  const allBooks = useAllBook();
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const dispatch = useDispatch();
  const [openVocabulary, setVocabulary] = useState(false);
  const [getBooksVocab, setGetBooksVocab] = useState([]);
  const [studentCognates, setStudentCognates] = useState([]);

  const [vocLoader, setVocLoader] = useState(false);
  const [assignmentAiModal, setAssignmentAiModal] = useState(false);
  const [generateQnALoader, setGenerateQnALoader] = useState(false);
  const [questionGenerator, setQuestionGenerator] = useState([]);
  const [questionLoader, setQuestionLoader] = useState(false);
  const [qnaWord, setQnAWord] = useState('');
  const [aiModal, setAiModal] = useState(false);
  const vocabdomRef = useRef();
  const exams = useExams();
  const isExam = useMemo(
    () =>
      exams?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)).includes(`${bookId}`),
    [exams],
  );
  const [tabSelector, setTabSelector] = useState({ type: 'congantes' });
  const isLandscape = useOrientation();
  const { stopAudio, setCurrentAudio } = useAudio();
  const [selectedWordCogantes, setSelectedWordCogantes] = useState([]);
  const tabSelectorTypeRef = useRef(tabSelector?.type);
  const [selectedTypes, setSelectedTypes] = useState(
    question_type_generate_more.map((option) => option.value),
  );
  const location = useLocation();
  const isMobile = useMobileDetect();
  const [generatedCount,SetGenerateCount] = useState(0)
  const questionRequestIdRef = useRef(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageCog, setCurrentPageCog] = useState(1);
  const itemsPerPage = 20;
  const current_book = useMemo(() => {
    return find(allBooks ?? [], ['id', bookId])?.subTopics || [];
  }, [allBooks, bookId]);
  const [fetchStudentWordCount, setFetchStudentWordCount] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('spanish');
  const [aiWithCog, setAiWithCog] = useState(false);
  
  // Permission logic
  const vocab_permission = useVoabPermissionForUser();
  const classTogglePermission = useClassTogglePermission();
  const bookOrder = useBookOrder();
  const isAdditionalBook = useIsAdditionalBook(bookId);
  const orgPermissions = useCurrentOrgPermission();
  const classStudents = filter(classUsers, (user) => user.role === 'student');
  const [generationLoader, setGenerationLoader] = useState(false);
  const [studentWordCounts, setStudentWordCounts] = useState([]);
  const {currentBookData ={}} = useBook();
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const [showAccordin, setShowAccordin] = useState(true);
  const [dimensions, setDimensions] = useState({});
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Check if cognates is allowed for the current book group
  const isCognatesAllowedForBookGroup = useMemo(() => {
    if (currentUser.role !== "student") return true; // Teachers always have access
    
    const currentBookGroup = bookOrder?.find(order => 
      order.order && order.order.includes(bookId)
    );

    if (!classTogglePermission.cognates) return true; // Default to allowed if no restrictions
    if (!has(classTogglePermission.cognates, currentBookGroup?.key || isAdditionalBook?.key)) return true;

    if (isAdditionalBook?.key) {
      if (orgPermissions[isAdditionalBook?.key]) {
        return classTogglePermission.cognates[isAdditionalBook?.key];
      }
    }
    // Check if cognates is allowed for this book group
    return classTogglePermission.cognates[currentBookGroup?.key];
  }, [currentUser.role, bookId, bookOrder, classTogglePermission.cognates, isAdditionalBook]);

  const handleAudioChecker = async () => {
    stopAudio();
    setCurrentAudio(null);
    await dispatch(setAudioChecker({ isPlaying: false }));
  };

  useEffect(() => {
    const updateWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, []);

  useEffect(() => {
    tabSelectorTypeRef.current = tabSelector?.type;
  }, [tabSelector?.type]);

  const handleTouch = (event) => {
    event.preventDefault();
    handleVocabularyClose();
  };


  useEffect(() => {
    if (isCheckingOpen) {
      setVocabulary(true);
      fetchStudentWordCounts();
    } else {
      setVocabulary(false);
    }
  }, [isCheckingOpen]);


  useEffect(() => {
    const data = {
      teacher_id:
        currentUser.role == 'student'
          ? get(currentClass, 'teacherId', '')
          : get(currentUser, 'id', ''),
      user_id: get(currentUser, 'id', ''),
      created_by: currentUser.role == 'student' ? 'student' : 'teacher',
      class_id: currentUser.role == 'student' ? get(currentClass, 'id') : null,
      page: pageId,
      book_id: bookId,
    };
    Promise.allSettled([
      dispatch(handleListVocabularyCogantes(data, bookId, pageId, currentUser?.id)),
    ]);
  }, []);

  useEffect(() => {
    if (!openVocabulary || currentUser?.role !== 'teacher' || !bookCognets?.length) return;
  if (tabSelector?.type === 'congantes') {
    const filterVocab = bookCognets?.filter((obj) => obj.page == pageId) || [];
    const filterByAdmin = filterVocab?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filterVocab?.filter((data) => data?.created_by === 'teacher') || [];
    const filteredCognates = [...filterByAdmin, ...filterByTeacher];
    setSelectedWordCogantes(filteredCognates || []);
    return;
  }
  if (tabSelector?.type === 'unit_cognates') {
    if (!current_book || current_book?.length === 0) return;
    const unit = findPageObject(pageId, current_book);
    if (!unit) return;
    const filteredData = (bookCognets || []).filter((item) => {
      const pageNumber = parseInt(item.page, 10);
      return (
        pageNumber >= parseInt(unit?.startPage, 10) &&
        pageNumber <= parseInt(unit?.finishPage, 10)
      );
    });
    const filterByAdmin = filteredData?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filteredData?.filter((data) => data?.created_by === 'teacher') || [];
    const data = [];
    if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
    if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
    setStudentCognates(data);
    setSelectedWordCogantes(data);
  }
}, [bookCognets, openVocabulary, pageId, tabSelector?.type, currentUser?.role, current_book])

  useEffect(() => {
    if (!assignmentAiModal) {
      questionRequestIdRef.current += 1;
      setQuestionGenerator([]);
      SetGenerateCount(0);
      setQuestionLoader(false);
      setGenerateQnALoader(false);
    }
  }, [assignmentAiModal]);

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: '', severity: 'success' });
  };
  const handleVocabularyClose = () => {
    handleAudioChecker();
    toogleChange('congantes');
    if (setVocModal) {
      setVocModal(false);
    }
    setVocabulary(false);
  };

  const toogleChange = (value) => {
    setTabSelector({ type: value });
    setCurrentPage(1);
    setCurrentPageCog(1);
  };


  const handleCreateVocabularyQnACogantes = async (key) => {
    try {
      const requestId = questionRequestIdRef.current + 1;
      questionRequestIdRef.current = requestId;
      if (!isAiPermissionEnabled) {
        showAlert('Please enable AI permission to generate questions.', 'error');
        return;
      }
      const words = selectedWordCogantes.map((item) => item.data?.word_spanish);
      const data = words.join(', ');
      if (selectedWordCogantes?.length === 0 || data === '')
        return showAlert('Select atleast one Cognates', 'info');

        setAssignmentAiModal(true);
        setGenerateQnALoader(true);
        handleVocabularyClose();

      await handleStreamResponse({
        path: "ai/generate/generate-questions-for-vocab",
        body: JSON.stringify({
          topic: data,
          language: 'spanish',
          generate_question_language: key,
          is_cognate: true
        }),
        onTitle: (title) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQnAWord(title)
          SetGenerateCount(0)
        },
        onQuestion: (question) => {
          if (questionRequestIdRef.current !== requestId) return;
          setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
          SetGenerateCount(prev => prev + 1)
          setQuestionLoader(false);
          setGenerateQnALoader(false);
        },
        onDone: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        },
        onError: () => {
          if (questionRequestIdRef.current !== requestId) return;
          setGenerateQnALoader(false);
          setQuestionLoader(false);
          SetGenerateCount(0)
        }
      })
    } catch (error) {
      Sentry.captureException(`257 Error in handleCreateVocabularyQnACogantes: ${error}`);
      console.log(error);
      setGenerateQnALoader(false);
      setQuestionLoader(false);
      SetGenerateCount(0)
    }
  };

  const handleGenerateMoreQnA = async (topic,key) => {
    const requestId = questionRequestIdRef.current + 1;
    questionRequestIdRef.current = requestId;
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate questions.', 'error');
      return;
    }
    setQuestionLoader(true);
    const words = selectedWordCogantes.map((item) => item.data?.word_spanish);
    const data = words.join(", ");
    await handleStreamResponse({
      path: "ai/generate/generate-questions-for-vocab",
      body: JSON.stringify({
        topic: data,
        question_type: selectedTypes,
        generate_question_language: key,
        is_cognate: true
      }),
      onTitle: (title) => {
        if (questionRequestIdRef.current !== requestId) return;
        setQnAWord(title)
        SetGenerateCount(0)
      },
      onQuestion: (question) => {
        if (questionRequestIdRef.current !== requestId) return;
        setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
        SetGenerateCount(prev => prev + 1)
        setQuestionLoader(false);
        setGenerateQnALoader(false);
      },
      onDone: () => {
        if (questionRequestIdRef.current !== requestId) return;
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0)
      },
      onError: () => {
        if (questionRequestIdRef.current !== requestId) return;
        setGenerateQnALoader(false);
        setQuestionLoader(false);
        SetGenerateCount(0)
      }
    })
    // const generatedQuestionData = await dispatch(
    //   handleCreateVocabularyAIQnA({
    //     topic,
    //     question_type: selectedTypes,
    //   }),
    // );
    // if (generatedQuestionData?.data?.length >= 0) {
    //   setQuestionLoader(false);
    //   setQuestionGenerator(generatedQuestionData?.data);
    // } else {
    //   showAlert('something went wrong please try with another page!', 'error');
    // }
  };


  const checkGenerateFromAi = async () => {
    try {
      if (!isAiPermissionEnabled) {
        showAlert('Please enable AI permission to generate content using AI.', 'error');
        return;
      }
      const filterVocab = bookCognets?.filter((obj) => obj.page == pageId);
      const filterByAdmin = filterVocab?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filterVocab?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [...filterByAdmin, ...filterByTeacher];

      const isShowAiAlert = data.some((data) => data.is_ai === true);

      const dataAi = {
        bookId,
        page: pageId,
        chapter: bookId,
        created_by: currentUser?.role,
        user_id: get(currentUser, 'id', ''),
        class_id: get(currentClass, 'id', ''),
        resource: from === 'resource' ? true : false,
      };

      handleVocabularyClose();

      const proceedWithAI = async () => {
        setAiModal(true);
        let generatedCount = 0;
         setGenerationLoader(false);
        await handleStreamResponseForCognates({
          path: 'ai/generate-cognates-stream',
          body: dataAi,
          onFirstResponse: () => {
            setAiModal(false);
            setVocabulary(true);
            toogleChange('congantes');
            setGenerationLoader(true);
          },
          onCognate: (cog) => {
            if (cog && cog.id) {
              dispatch(createVocabularySuccessCogantes(cog))
            }
            generatedCount++;
          },
          onDuplicate: (dup) => {
          },
          onDone: () => {
             if(generatedCount === 0){
              setAlertSakeBar({
                open: true,
                message: "This page doesn't contain any data.",
                severity: 'error',
              });
            }
            setGenerationLoader(false);
          },
          onError: (err) => {
            setGenerationLoader(false);
            setAiModal(false);
            setAlertSakeBar({
              open: true,
              message: "Something went wrong, please try again later.",
              severity: 'error',
            });
            console.error('Error in AI stream:', err);
          }
        })
      };

      if (isShowAiAlert) {
        confirm({
          title: 'Confirm',
          content: `You've already generated contents on this page. Are you sure you want to regenerate them?`,
          okText: 'Continue',
          okButtonProps: {
            className: 'force-blue-button',
            style: {
              backgroundColor: '#012B70 !important',
              borderColor: '#012B70 !important',
            },
          },
          onOk: async (close) => {
            close();
            await proceedWithAI();
          },
          onCancel: () => {
            setVocabulary(true);
           // setSelectedAIVocab(getBooksVocab || []);
            toogleChange('congantes');
          },
        });
      } else {
        await proceedWithAI();
      }
    } catch (error) {
      Sentry.captureException(`258 Error in checkGenerateFromAi: ${error}`);
      console.log(error);
    }
  };

  const handleCheckboxChangeForCogantes = (checked, value) => {
    if (checked) {
      setSelectedWordCogantes((prev) => [...prev, value]);
    } else {
      setSelectedWordCogantes((prev) => prev.filter((item) => item.id !== value.id));
    }
  };

  const onCallStudentVocab = async (id, type) => {
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to generate content using AI.', 'error');
      return;
    }
    const targetTab = type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog';
    setVocLoader(true);
    const data = {
      teacher_id: get(currentUser, 'id', ''),
      user_id: id,
      created_by: 'teacher_student',
      page: pageId,
      book_id: bookId,
    };
    try {
      if (type === 'vocabulary') {
        const selectedStudentData = await dispatch(
          handleListVocabularyStud(data, bookId, pageId, currentUser?.id),
        );
        const vocabList = Array.isArray(selectedStudentData) ? selectedStudentData : [];
        if (tabSelectorTypeRef.current !== targetTab) {
          return;
        }
        setGetBooksVocab(vocabList);
      } else {
        const selectedStudentCognate = await dispatch(
          handleListVocabularyCogStud(data, bookId, pageId, currentUser?.id),
        );
        const cognateList = Array.isArray(selectedStudentCognate) ? selectedStudentCognate : [];
        if (tabSelectorTypeRef.current !== targetTab) {
          return;
        }
        setStudentCognates(cognateList);
        setSelectedWordCogantes(cognateList);
      }
    } finally {
      setVocLoader(false);
    }
  };
       const fetchStudentWordCounts = async (pageSpecific = true) => {
         setFetchStudentWordCount(true);
          try {
            const classId = get(currentClass, 'id');
    
            if (!classId || !bookId) {
              console.warn('Missing required parameters:', { classId, bookId });
              setStudentWordCounts([]);
              return [];
            }
    
            const data = {
              class_id: classId,
              book_id: bookId,
              type: "cognates",
              ...(pageSpecific && { page: pageId }),
            };
    
            const counts = await dispatch(handleGetStudentWordCount(data));
            if (Array.isArray(counts)) {
              setStudentWordCounts(counts);
              setFetchStudentWordCount(false);
              return counts;
            } else {
              console.warn('Student word counts API returned non-array data:', counts);
              setStudentWordCounts([]);
              setFetchStudentWordCount(false);
              return [];
            }
          } catch (error) {
            console.error('Error fetching student word counts:', error);
            setStudentWordCounts([]);
            setFetchStudentWordCount(false);
            return [];
          }
        };
        
        const getStudentWordCount = (studentId) => {
            if (!Array.isArray(studentWordCounts)) {
                 return 0;
             }
           const student = studentWordCounts.find(s => s.id === studentId);
           return student ? student.word_count : 0;
       };
    
       const StudentItems =
         classStudents?.map((item) => {
           const wordCount = getStudentWordCount(item.id);
           return {
             key: item.id,
             label: (
               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                 <span>{`${item.firstName} ${item.lastName}`}</span>
                 <span style={{
                   backgroundColor: '#5d4187',
                   color: 'white',
                   borderRadius: '12px',
                   padding: '2px 8px',
                   fontSize: '12px',
                   fontWeight: 'bold',
                   minWidth: '20px',
                   textAlign: 'center',
                   marginLeft: '8px'
                 }}>
                   {wordCount}
                 </span>
               </div>
             ),
             wordCount: wordCount
           };
         }).sort((a, b) => b.wordCount - a.wordCount) || [];

  const StudentVocabulary = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const touchStartY = useRef(null);
    const isScrolling = useRef(false);


    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          const target = event.target;
          const isDropdownButton = target.closest('button.minWith') || 
                                   target.closest('[data-dropdown="true"]') ||
                                   target.closest('.dropdown-scrollable');
          if (!isDropdownButton) {
            setIsOpen(false);
          }
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleTouchStart = (e) => {
      touchStartY.current = e.touches[0].clientY;
      isScrolling.current = false;
    };

    const handleTouchMove = (e) => {
      if (touchStartY.current !== null) {
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY.current);
        if (deltaY > 5) {
          isScrolling.current = true;
        }
      }
    };

    const handleItemClick = (key, e) => {
      if (isScrolling.current && e && e.type === 'touchstart') {
        return;
      }
      toogleChange('my_student_cog');
      onCallStudentVocab(key, type);
      setIsOpen(false);
    };

    return (
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <Button
          className={`minWith ${tabSelector?.type === (type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog') ? 'selected selected-background-color' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {'Student Cognates'}
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button>

        {isOpen && (
          <div
            data-dropdown="true"
            className="dropdown-scrollable"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px',
              zIndex: 1000,
              minWidth: '200px',
              maxHeight: '200px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y'
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            {items.map((item) => (
              <div
                key={item.key}
                onClick={(e) => handleItemClick(item.key, e)}
                onTouchEnd={(e) => {
                  if (!isScrolling.current) {
                    handleItemClick(item.key, e);
                  }
                  touchStartY.current = null;
                  isScrolling.current = false;
                }}
                style={{
                   padding: '8px 12px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    touchAction: 'pan-y',
                                    WebkitTouchCallout: 'none',
                                    userSelect: 'none',
                                    ':hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {item.label}
                <span
                  style={{
                    backgroundColor: '#5d4187',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    minWidth: '20px',
                    textAlign: 'center',
                  }}
                >
                  {item.wordCount}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const findPageObject = (pageID, data) => {
    return data.find(
      (item) =>
        Number(pageID) >= Number(item?.startPage) && Number(pageID) <= Number(item?.finishPage),
    );
  };



  const onManageCognatesMenu = async (id, type) => {
    if (id === 'cognate') {
      setTabSelector({ type: 'congantes' });
      setSelectedWordCogantes(selectedWordCogantes);
    } else if (id === 'unit_cognates') {
      if (current_book?.length === 0) {
        showAlert('Unit not found in this book.', 'info');
        return;
      }
      setTabSelector({ type: 'unit_cognates' });
      const findUnit = findPageObject(pageId, current_book);
      const filteredData = bookCognets.filter((item) => {
        const pageNumber = parseInt(item.page, 10);
        return (
          pageNumber >= parseInt(findUnit?.startPage, 10) &&
          pageNumber <= parseInt(findUnit?.finishPage, 10)
        );
      });
      const filterByAdmin = filteredData?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filteredData?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [];
      if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
      if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
      setStudentCognates(data);
      setSelectedWordCogantes(data);
    }
  };

  const AllCognates = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);


    const items = [
      {
        key: 'cognate',
        label: 'Page Cognates',
      },
      ...(location.pathname === '/ebook' && currentBookData?.structures?.length > 0
        ? [
            {
              key: 'unit_cognates',
              label: 'Unit Cognates',
            },
          ]
        : []),
    ].filter(Boolean);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          const target = event.target;
          const isDropdownButton = target.closest('button.minWith') || 
                                   target.closest('[data-dropdown="true"]') ||
                                   target.closest('.dropdown-scrollable');
          if (!isDropdownButton) {
            setIsOpen(false);
          }
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleItemClick = (key) => {
      onManageCognatesMenu(key, type);
      setIsOpen(false);
    };

    return (
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <Button
          className={`minWith ${tabSelector?.type === 'congantes' || tabSelector?.type === 'unit_cognates' ? 'selected selected-background-color' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          {tabSelector?.type === 'congantes'
            ? 'Page Cognates'
            : tabSelector?.type === 'unit_cognates'
              ? 'Unit Cognates'
              : 'Cognates'}
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button>

        {isOpen && (
          <div
            data-dropdown="true"
            className="dropdown-scrollable"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px',
              zIndex: 1000,
              minWidth: '200px',
              maxHeight: '200px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y'
            }}
          >
            {items.map((item) => (
              <div
                key={item.key}
                onClick={(e) => {
                  e.stopPropagation();
                  handleItemClick(item.key);
                }}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                  ':hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const items = [
    {
      key: 'cognate',
      label: 'Page Cognates',
    },
    ...(location.pathname === '/ebook' && currentBookData?.structures?.length > 0
      ? [
          {
            key: 'unit_cognates',
            label: 'Unit Cognates',
          },
        ]
      : []),
  ].filter(Boolean);
  const AllCognatesTest = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);



    // useEffect(() => {
    //   const handleClickOutside = (event) => {
    //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //       const target = event.target;
    //       const isDropdownButton = target.closest('button.minWith') || 
    //                                target.closest('[data-dropdown="true"]') ||
    //                                target.closest('.dropdown-scrollable');
    //       if (!isDropdownButton) {
    //         setIsOpen(false);
    //       }
    //     }
    //   };

    //   document.addEventListener('mousedown', handleClickOutside);
    //   return () => {
    //     document.removeEventListener('mousedown', handleClickOutside);
    //   };
    // }, []);

    const handleItemClick = (key) => {
      onManageCognatesMenu(key, type);
      setIsOpen(false);
    };

    return (
      <div>
       {/* <div ref={dropdownRef} style={{ position: 'relative' }}> */}
        <Dropdown
                  menu={{ items: items, onClick: handleItemClick }}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                  getPopupContainer={() => document.body}
              >
                  <Button className='create-with-ai-button minWith'>
                  {tabSelector?.type === 'congantes'
            ? 'Page Cognates test'
            : tabSelector?.type === 'unit_cognates'
              ? 'Unit Cognates test'
              : 'Cognates test'}
                      <KeyboardArrowDown />
                  </Button>
              </Dropdown>
        {/* <Button
          className={`minWith ${tabSelector?.type === 'congantes' || tabSelector?.type === 'unit_cognates' ? 'selected selected-background-color' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          {tabSelector?.type === 'congantes'
            ? 'Page Cognates'
            : tabSelector?.type === 'unit_cognates'
              ? 'Unit Cognates'
              : 'Cognates'}
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button> */}

        {/*    {isOpen && ( */}
        {/*   <div
        //     data-dropdown="true"
        //     className="dropdown-scrollable"
        //     style={{
        //       position: 'absolute',
        //       top: '100%',
        //       left: 0,
        //       backgroundColor: '#fff',
        //       boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        //       borderRadius: '4px',
        //       zIndex: 1000,
        //       minWidth: '200px',
        //       maxHeight: '200px',
        //       overflowY: 'auto',
        //       WebkitOverflowScrolling: 'touch',
        //       touchAction: 'pan-y'
        //     }}
        //   >
        //     {items.map((item) => (
        //       <div
        //         key={item.key}
        //         onClick={(e) => {
        //           e.stopPropagation();
        //           handleItemClick(item.key);
        //         }}
        //         style={{
        //           padding: '8px 12px',
        //           cursor: 'pointer',
        //           transition: 'background-color 0.3s',
        //           ':hover': {
        //             backgroundColor: '#f5f5f5',
        //           },
        //         }}
        //         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
        //         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
        //       >
        //         {item.label}
        //       </div>
        //     ))}
        //   </div>
        // )} */}
      </div>
    );
  };

  const handleItemClickTest = (key) => {
    onManageCognatesMenu(key?.key);
    // setIsOpen(false);
  };

  // const generated_question = useMemo(
  //   () => questionGenerator.map((k) => ({ ...k, id: Math.random() * 1000000000 })),
  //   [questionGenerator],
  // );

  const RenderMenuContent = () => {
    const menuItems = [
      ...(get(currentUser, 'role') === 'teacher'
        ? [
            {
              key: 'cognate',
              label: 'Page Cognates',
              onClick: () => onManageCognatesMenu('cognate'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'teacher' && location.pathname === '/ebook'
        ? [
            {
              key: 'unit_cognates',
              label: 'Unit Cognates',
              onClick: () => onManageCognatesMenu('unit_cognates'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'teacher' && !isExam
        ? [
            {
              key: 'cognates_with_ai',
              label: 'Cognates with AI',
              onClick: () => checkGenerateFromAi(),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'student'
        ? [
            {
              key: 'congantes',
              label: 'Cognates',
              onClick: () => toogleChange('congantes'),
            },
          ]
        : []),
      ...(get(currentUser, 'role') === 'student'
        ? [
            {
              key: 'my_cogants',
              label: 'My Cognates',
              onClick: () => toogleChange('my_cogants'),
            },
          ]
        : []),
    ];

    return menuItems.map(item => ({
      key: item.key,
      label: item.onClick ? <div onClick={item.onClick}>{item.label}</div> : item.label
    }));
  };

  const handleLanguageChange = ({ key }) => {
    setSelectedLanguage(key);
    handleCreateVocabularyQnACogantes(key);
  }

  const handleItemClickStudentCognates = (key) => {
    toogleChange('my_student_cog');
    onCallStudentVocab(key?.key, 'cognates');
  };


  return (
    <SentryWrap>
    <div
      ref={ref}
      tabIndex={0}      
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: '' });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <CognateAiLoader aiModal={aiModal} />

      {/* {isCognatesAllowedForBookGroup && ( */}
        <Button
          style={{
            borderRadius: '0px !important',
            minWidth: 'unset',
            height: '36px',
            marginLeft: currentUser?.role === 'student' && 0,
            ...(style ? style : {}),
          }}
          onClick={() => {
            closeToolsDropdown();
            setVocabulary(!openVocabulary);
            fetchStudentWordCounts();
           // setSelectedAIVocab(getBooksVocab || []);
          }}
          // className={`vocabularyBtn vocDeskTab scheduledWeb ${vocabilaryButtonClassName}`}
          className={`${isVocabulary ? 'videoSectionVocab' : `111 vocabularyBtn vocDeskTab cognatesResoureceBtn ${vocabilaryButtonClassName}`}`}
        >
          Cognates
        </Button>
      {/* )} */}
      {openVocabulary && (
            <ResizeAndDragabble
              style={{zIndex: 999999999}}
              defaultValue={{
                x: windowSize?.width < 768 ? (windowSize?.width - windowSize?.width * 0.7) / 2 : (windowSize?.width - Math.min(windowSize?.width - 40, 700)) / 2,
                y: windowSize?.height < 600 ? 10 : (windowSize?.height - Math.min(windowSize?.height - 40, 500)) / 2,
                width: windowSize?.width < 768 ? windowSize?.width * 0.7 : Math.min(windowSize?.width - 40, 700),
                height: windowSize?.height < 600 ? windowSize?.height * 0.7 : Math.min(windowSize?.height - 40, 500),
              }}
              size={dimensions?.width && dimensions?.height ? dimensions : undefined}
              minHeight={200}
              minWidth={windowSize?.width < 768 ? windowSize?.width * 0.5 : 300}
              maxWidth={windowSize?.width < 768 ? windowSize?.width : windowSize?.width - 40}
              maxHeight={windowSize?.width < 768 ? windowSize?.height * 0.8 : windowSize?.height - 60}
              resize={(data) => setDimensions(data)}
              resizeEnd={(data) => setDimensions(data)}
              aspectRatio={false}
              showAccordin={showAccordin}
              center={false}
            >
              <ModalContent isLandscape={isLandscape} className="vocabulContents vocabulContentsWidget" style={{
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                zIndex: 999999999,
                position: "relative"
              }}>
                <div className="checkListFirstTxt absolute top-0 w-full pt-17px pb-14px br-topLeft-topRight-20px" style={{ pointerEvents: 'none' }}>
                  <span className="text-white text-ft12-700 cognatesTrack">Cognates</span>
                </div>
         
          <CrossPrint className='genCognatesCmn genCognatesForLoader' style={{ pointerEvents: 'auto' }}>
            <div className='genCognatesCstm'>
               {generationLoader && <label>Generating Cognates</label>}
               <ItemLoader loading={generationLoader} />
            </div>

            <div className='genCognatesInfo'>
            <AIUsageInfo />
            {get(currentUser, 'role') === 'teacher' && (
              <VocabPrint
                data={
                  tabSelector?.type === 'congantes'
                    ? selectedWordCogantes
                    : tabSelector?.type === 'unit_cognates'
                      ? studentCognates
                      : tabSelector?.type === 'my_student_cog'
                        ? studentCognates
                        : getBooksVocab
                }
                toggleType={tabSelector?.type}
              />
            )}
            <Close color="secondary" onClick={handleVocabularyClose} className="12 vocablaryClose" />
            </div>

          </CrossPrint>
            <div className="VocabularyTabWidget VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px" style={{ pointerEvents: 'auto' }}>
              {(get(currentUser, 'role') === 'teacher' || currentUser?.role === 'admin') && (
                <>
                  {get(currentUser, 'role') === 'teacher' && location.pathname === '/ebook' ? (
                    <>
                    {/* <AllCognates />
                    <AllCognatesTest /> */}
                    {!isOnlyForTeacher && (
                      <Dropdown
                        menu={{ items: items, onClick: handleItemClickTest }}
                        trigger={['click']}
                        placement="bottomRight"
                        overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                        getPopupContainer={() => document.body}
                      >
                          <Button className={`minWith ${tabSelector?.type === 'congantes' || tabSelector?.type === 'unit_cognates' ? 'selected selected-background-color' : ''}`}>
                          {tabSelector?.type === 'congantes'
                            ? 'Page Cognates'
                            : tabSelector?.type === 'unit_cognates'
                              ? 'Unit Cognates'
                              : 'Cognates'}
                              <KeyboardArrowDown />
                          </Button>
                      </Dropdown>
                    )}
                    </>
                  ) : (
                    <Button
                      className={
                        tabSelector?.type === 'congantes'
                          ? 'selected selected-background-color'
                          : ''
                      }
                      onClick={() => {
                        onManageCognatesMenu('cognate');
                      }}
                    >
                      Page Cognates
                    </Button>
                  )}
                </>
              )}
              {get(currentUser, 'role') === 'student' && (
                <Button
                  className={
                    tabSelector?.type === 'congantes' ? 'selected selected-background-color' : ''
                  }
                  onClick={() => {
                    toogleChange('congantes');
                    setSelectedWordCogantes(selectedWordCogantes);
                  }}
                >
                  Cognates
                </Button>
              )}
              {get(currentUser, 'role') === 'student' && (
                <Button
                  className={
                    tabSelector?.type === 'my_cogants' ? 'selected selected-background-color' : ''
                  }
                  onClick={() => toogleChange('my_cogants')}
                >
                  My Cognates
                </Button>
              )}

              {get(currentUser, 'role') === 'teacher' && !isExam && (
                <Button
                  className="create-with-ai-button minWith"
                  onClick={() => checkGenerateFromAi()}
                >
                  Cognates with AI
                </Button>
              )}
              {currentUser?.role === 'teacher' && !isExam && !isOnlyForTeacher && (
                  <Dropdown
                  menu={{ items: languageMenuItems, onClick: handleLanguageChange }}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                  getPopupContainer={() => document.body}
              >
                  <Button className='create-with-ai-button minWith'>
                       AI Act. with Cognates
                      <KeyboardArrowDown />
                  </Button>
              </Dropdown>
           )}
              {/* {get(currentUser, 'role') === 'teacher' && (
                <StudentVocabulary
                  type="cognates"
                  data={{ currentUser }}
                />
              )} */}
              {get(currentUser, 'role') === 'teacher' && (
                <Dropdown
                  menu={{ 
                    items: StudentItems, 
                    onClick: handleItemClickStudentCognates
                  }}
                  trigger={['click']}
                  placement="bottomRight"
                  overlayStyle={{ zIndex: DROPDOWN_Z_INDEX }}
                  getPopupContainer={() => document.body}
                  dropdownRender={(menu) => (
                    <div style={{ maxHeight: '220px', overflowY: 'auto', borderRadius: 8 }}>
                      {menu}
                    </div>
                  )}
                >
                  <Button className={`minWith ${tabSelector?.type === 'my_student_cog' ? 'selected selected-background-color' : ''}`}>
                    Student Cognates
                    <KeyboardArrowDown />
                  </Button>
                </Dropdown>
              )}
            </div>

          <div className="vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth vocInMobileWidget dropdown-scrollable cursor-default" data-dropdown="true" ref={vocabdomRef}>
            {(tabSelector?.type === 'congantes' ||
              tabSelector?.type === 'my_cogants' ||
              tabSelector?.type === 'my_student_cog' ||
              tabSelector?.type === 'unit_cognates') && (
              <Cogantes
                studentCognates={studentCognates}
                selectedWordCogantes={selectedWordCogantes}
                setSelectedWordCogantes={setSelectedWordCogantes}
                handleCheckboxChangeForCogantes={handleCheckboxChangeForCogantes}
                handleVocabularyClose={handleVocabularyClose}
                tabSelector={tabSelector}
                refs={{ vocabdomRef }}
                stopAudio={stopAudio}
                bookId={bookId}
                pageId={pageId}
                pageNumber={pageNumber}
                vocLoader={vocLoader}
                isCognatesAllowedForBookGroup={isCognatesAllowedForBookGroup}
              />
            )}
          </div>
              </ModalContent>
            </ResizeAndDragabble>
        )}
      {assignmentAiModal && (
        <QnALoader
          assignmentAiModal={assignmentAiModal}
          setAssignmentAiModal={setAssignmentAiModal}
          handleGenerateMoreQnA={handleGenerateMoreQnA}
          generateQnALoader={generateQnALoader}
          questionGenerator={questionGenerator}
          setQuestionGenerator={setQuestionGenerator}
          page={pageId}
          chapter={bookId}
          qnaWord={qnaWord}
          loading={questionLoader}
          pageNumber={pageNumber}
          selectedTypes={selectedTypes}
          setSelectedTypes={setSelectedTypes}
          generatedCount={generatedCount}
          from="cognates"
        />
      )}
    </div>
    </SentryWrap>);
};

export default CognatesComponent;
